import { createContext, useEffect, useState } from "react";

export const selectDropdownContext = createContext("");

//User Auth context
const AuthContext = createContext();
//plan context
const PlanContext = createContext();

//auth context provider
//auth context provider
const AuthProvider = ({ children }) => {
  // Safe initialization
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("User");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
      return null;
    }
  });

  // Initialize user state from localStorage
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("User");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
      setUser(null);
    }
  }, []);

  // Function to handle login
  const login = (userData) => {
    try {
      localStorage.setItem("User", JSON.stringify(userData));
      setUser(userData);
    } catch (error) {
      console.error("Error saving user to localStorage:", error);
    }
  };

  // Function to handle logout
  const logout = () => {
    localStorage.removeItem("User");
    localStorage.removeItem("plan");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

//plan context provider
//plan context provider
const PlanProvider = ({ children }) => {
  // Safe initialization - check if localStorage item exists before parsing
  const [plan, setPlan] = useState(() => {
    try {
      const storedPlan = localStorage.getItem("plan");
      return storedPlan ? JSON.parse(storedPlan) : null;
    } catch (error) {
      console.error("Error parsing plan from localStorage:", error);
      return null;
    }
  });

  useEffect(() => {
    try {
      const storedPlan = localStorage.getItem("plan");
      setPlan(storedPlan ? JSON.parse(storedPlan) : null);
    } catch (error) {
      console.error("Error parsing plan from localStorage:", error);
      setPlan(null);
    }
  }, []);

  const setPlanData = (planData) => {
    try {
      if (planData) {
        localStorage.setItem("plan", JSON.stringify(planData));
        setPlan(planData);
      } else {
        localStorage.removeItem("plan");
        setPlan(null);
      }
    } catch (error) {
      console.error("Error saving plan to localStorage:", error);
    }
  };

  return (
    <PlanContext.Provider value={{ plan, setPlanData }}>
      {children}
    </PlanContext.Provider>
  );
};
export { AuthContext, AuthProvider, PlanContext, PlanProvider };
// export default selectDropdownContext;
